export default function KeyboardNavFactory(searchBarFactory) {
    var factory = this;

    /**
     * [focusDropdownList description]
     * @param  {obj} event     the keyboard event
     * @param  int direction      up = -1, down = 1
     *
     * @return nothing
     */
    factory.doActionOnActiveDropdown = function (event, direction) {
        // console.log("doActionOnActiveDropdown", searchBarFactory.oSearchActive);

        if (
            searchBarFactory.oSearchActive &&
            searchBarFactory.oSearchActive.activeDropdown
        ) {
            //when body is in focus we need to prevent body jump on keypress
            event.preventDefault();

            searchBarFactory.looseFocusInput(searchBarFactory.oSearchActive);

            if (searchBarFactory.oSearchActive.name == "search-activity") {
                if (event.key == "ArrowDown" || event.key === "ArrowUp") {
                    factory.dropdownCategoryNavUpDown(
                        searchBarFactory.oSearchActive.items,
                        searchBarFactory.oSearchActive,
                        direction
                    );
                }

                if (event.key == "ArrowRight" || event.key == "ArrowLeft") {
                    factory.dropdownCategoryNavRightLeft(
                        event,
                        searchBarFactory.oSearchActive
                    );
                }

                if (event.key == "Enter") {
                    console.log("Do Suggestions on Enter");

                    factory.doSuggestions(searchBarFactory.oSearchActive);

                    //console.log('ENTER KEY -SEARCH CATEGORY- CALLS');
                    //searchBarFactory.userLeavingInput( searchBarFactory.oSearchActive );

                    //searchBarFactory.openNextDropdown(searchBarFactory.oSearchActive);
                }
            }

            if (searchBarFactory.oSearchActive.name == "search-location") {
                if (event.key == "ArrowDown" || event.key === "ArrowUp") {
                    factory.dropdownCategoryNavUpDown(
                        searchBarFactory.oSearchActive.items,
                        searchBarFactory.oSearchActive,
                        direction
                    );
                }

                if (event.key == "Enter") {
                    //console.log('Do Suggestions on Enter');

                    factory.doSuggestions(searchBarFactory.oSearchActive);

                    //console.log('ENTER KEY -SEARCH TYPE- CALLS');

                    //searchBarFactory.userLeavingInput(searchBarFactory.oSearchActive );

                    //searchBarFactory.openNextDropdown(searchBarFactory.oSearchActive);
                }
            }

            // if (searchBarFactory.oSearchActive.name == "search-calender") {
            // }
        }
    };

    factory.dropdownCategoryNavRightLeft = function (event, oSearchActive) {
        if (event.key == "ArrowRight") {
            searchBarFactory.showSubMenu(
                oSearchActive.items,
                oSearchActive.hightligtedItem.CategoryID,
                oSearchActive
            );
        }

        if (event.key == "ArrowLeft") {
            if (oSearchActive.dropDownState.activeMenuParentId !== 0) {
                searchBarFactory.backToRootMenu(searchBarFactory.oSearchActive);
            }
        }
    };

    factory.dropdownCategoryNavUpDown = function (
        arrayOfItems,
        oSearchActive,
        direction
    ) {
        // Flat structure -> When user has typed an input property filter
        if (oSearchActive.filter) {
            searchBarFactory.looseFocusInput(oSearchActive);

            factory.jumpToDropdownCategoryFunc(
                oSearchActive.filteredItems.filterInUse,
                oSearchActive,
                direction
            );

            searchBarFactory.setSuggestedItem(
                oSearchActive,
                oSearchActive.hightligtedItem
            );
        }

        // tree Ul root/parent (no text input) (activeMenuParentId  ID)
        if (
            !oSearchActive.filter &&
            oSearchActive.dropDownState.activeMenuParentId == 0
        ) {
            factory.jumpToDropdownCategoryFunc(
                arrayOfItems,
                oSearchActive,
                direction
            );
        }

        // tree Ul children (no text input) (activeMenuParentId ID)
        if (
            !oSearchActive.filter &&
            oSearchActive.dropDownState.activeMenuParentId !== 0
        ) {
            factory.jumpToDropdownCategoryFunc(
                oSearchActive.dropDownState.children,
                oSearchActive,
                direction
            );

            if (!oSearchActive.hightligtedItem.isBackToRootMenuItem) {
                factory.doSuggestions(oSearchActive);
            }
        }
    };

    factory.jumpToDropdownCategoryFunc = function (
        array,
        oSearchActive,
        direction
    ) {
        let foundIndex = array.indexOf(oSearchActive.hightligtedItem);

        if (foundIndex == -1) {
            // Select First
            oSearchActive.hightligtedItem = array.find((obj) => {
                return obj.active;
            });
            // } else if (foundIndex == 0 && direction == -1) {
            //     console.log("first item going up");
            //     // Set Focus on tilbage knap
        } else {
            let nextObj = null;
            if (direction == 1) {
                nextObj = array.find((obj, index) => {
                    // down
                    if (index > foundIndex && obj.active) {
                        return true;
                    }
                    // //up
                    // if (direction == -1 && index < foundIndex && obj.active) {
                    //     return true;
                    // }
                });
            }

            if (direction == -1) {
                // Reverse it to find next going up

                const reversedArr = angular.copy(array).reverse();
                var foundReversedIndex = reversedArr.findIndex(
                    (x) => x.Name === oSearchActive.hightligtedItem.Name
                );

                nextObj = reversedArr.find((obj, index) => {
                    // up
                    if (index > foundReversedIndex && obj.active) {
                        return true;
                    }
                });
            }

            if (!oSearchActive.hightligtedItem == "close-btn") {
                console.log("was Close Btn");
                oSearchActive.hightligtedItem = array[0];
            }

            let newIndex = -1;
            if (nextObj) {
                const nextObjIndex = array.findIndex(
                    (x) => x.Name === nextObj.Name
                );

                // Select Next
                oSearchActive.hightligtedItem = array[nextObjIndex];
                newIndex = array.indexOf(oSearchActive.hightligtedItem);
            }

            if (!nextObj) {
                console.log("No nextObj");
                oSearchActive.hightligtedItem = "close-btn";
            }

            if (newIndex == -1) {
                // aka not found - first or last array index

                if (direction == 1) {
                    // if down on last elem do nothing!
                }

                if (direction == -1) {
                    // if up on first elem - Go to Close Btn!

                    searchBarFactory.focusCloseBtn(oSearchActive);
                    // oSearchActive.hightligtedItem = {}; // reset

                    // if up
                    // if (oSearchActive.filter.length == 0) {
                    //     oSearchActive.input = "";
                    // }
                    // searchBarFactory.deactivateDropdown(oSearchActive);
                    // searchBarFactory.gainFocusInput(oSearchActive);
                }
            }
        }
        console.log("hightligtedItem", oSearchActive.hightligtedItem);
        if (oSearchActive.hightligtedItem) {
            searchBarFactory.resetAllTabindexOnItems(oSearchActive);

            // set Focus on element in dropdown
            searchBarFactory.setFocusItem(
                factory.getItemId(
                    oSearchActive.hightligtedItem,
                    oSearchActive.name
                ),
                "#" + oSearchActive.name + " ~ .aBook-dropdown"
            );
        }
    };

    factory.getItemId = function (obj, oSearchActiveName) {
        if (oSearchActiveName == "search-activity") {
            return obj.CategoryID;
        }
        if (oSearchActiveName == "search-location") {
            return obj.ID;
        }
    };

    factory.doSuggestions = function (oSearchActive) {
        // avail param : oSearchActive

        searchBarFactory.setSuggestedItem(
            oSearchActive,
            oSearchActive.hightligtedItem
        );
    };

    factory.jumpToDropdownType = function () {
        // avail param : oSearchActive
        // console.log('type')
        // console.log(oSearchActive);
    };

    return factory;
}
